export default "__VITE_ASSET__vCzXGqbS__"